export const FETCH_EMPLOYEES_REQUEST = 'FETCH_EMPLOYEES_REQUEST';
export const FETCH_EMPLOYEES_FAIL = 'FETCH_EMPLOYEES_FAIL';
export const FETCH_EMPLOYEES_SUCCESS = 'FETCH_EMPLOYEES_SUCCESS';

export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_FAIL = 'FETCH_PROJECTS_FAIL';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';

export const FETCH_PROJECTCATEGORIES_REQUEST = 'FETCH_PROJECTCATEGORIES_REQUEST';
export const FETCH_PROJECTCATEGORIES_FAIL = 'FETCH_PROJECTCATEGORIES_FAIL';
export const FETCH_PROJECTCATEGORIES_SUCCESS = 'FETCH_PROJECTCATEGORIES_SUCCESS';

export const PROJECTS_FILTER_UPDATE = 'PROJECTS_FILTER_UPDATE';

export const FETCH_PAGES_REQUEST = 'FETCH_PAGES_REQUEST';
export const FETCH_PAGES_FAIL = 'FETCH_PAGES_FAIL';
export const FETCH_PAGES_SUCCESS = 'FETCH_PAGES_SUCCESS';

export const FETCH_NEWS_REQUEST = 'FETCH_NEWS_REQUEST';
export const FETCH_NEWS_FAIL = 'FETCH_NEWS_FAIL';
export const FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS';

export const FETCH_SERVICES_REQUEST = 'FETCH_SERVICES_REQUEST';
export const FETCH_SERVICES_FAIL = 'FETCH_SERVICES_FAIL';
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';

export const FETCH_SITEOPTIONS_REQUEST = 'FETCH_SITEOPTIONS_REQUEST';
export const FETCH_SITEOPTIONS_FAIL = 'FETCH_SITEOPTIONS_FAIL';
export const FETCH_SITEOPTIONS_SUCCESS = 'FETCH_SITEOPTIONS_SUCCESS';

export const TOGGLE_MENU = 'TOGGLE_MENU';



// WEBPACK FOOTER //
// ./src/actions/types.js